import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

export default class SettingsBillingRouteTemplate extends Component {
	@service('billing') declare billingService: Service.Billing;
	@service('model-manager/users') declare mmUsersService: Service.ModelManager.Users;
	@service('account') declare accountService: Service.Account;

	get isVIP() {
		return this.billingService.activePlan?.isVIP;
	}

	get isAgencyClient() {
		return this.accountService.isClient;
	}

	get agencyAdmin() {
		return this.mmUsersService.agencyAdminRecordForClientSpace;
	}

	<template>
		<div class="top-margin">
			{{#if this.isAgencyClient}}
				Contact your organization for more information
				{{#if this.agencyAdmin}}
					:
					{{this.agencyAdmin.name}}
					(
					<a href="mailto:{{this.agencyAdmin.email}}">
						{{this.agencyAdmin.email}}
					</a>
					)
				{{/if}}
				.
			{{else if this.isVIP}}
				You are on a
				<strong>VIP</strong>
				plan. Nothing here for you to worry about.
			{{else}}
				{{outlet}}
			{{/if}}
		</div>
	</template>
}
